<template>
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
  >
    <v-inner :size="3">
      <v-input
        type="select"
        v-model="data.contract.cancellation_reason_id"
        :options="cancellationReasonsData"
        option_label_list="description"
        placeholder="Motivo do cancelamento"
      ></v-input>
      <v-input
        type="textarea"
        rows="5"
        v-model="data.contract.reject_description"
        >Digite aqui o seu motivo.</v-input
      >
      <v-row :size="2">
        <v-col :md="6">
          <v-button
            class="primary block"
            @click="cancelContract()"
            :disabled="disableCancellation"
            >Confirmar</v-button
          >
        </v-col>
        <v-col :md="6">
          <v-button class="gray block" @click="hide()">Agora não</v-button>
        </v-col>
      </v-row>
    </v-inner>
  </v-modal>
</template>
<script>
import vibbranteApi from '@/api/vibbrante';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'vibbrante',
    },
    data: {
      cancellationReasonsData: [],
    },
  },
  components: {},
  data() {
    return {
      action_success: false,
      cancellationReasonsData: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    disableCancellation() {
      return this.data.contract.cancellation_reason_id === undefined;
    },
  },
  methods: {
    fetchData() {
      vibbranteApi
        .vibbranteLoadCancellationReasons()
        .then(response => {
          this.cancellationReasonsData = [];
          response.data.forEach(element => {
            this.cancellationReasonsData.push(element);
          });
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    hide() {
      this.onHide();
      this.show = false;
    },
    onShow() {},
    onHide() {
      this.refresh = false;
      this.$emit('onHide');
      // OK vars
      this.action_success = false;
    },
    cancelContract() {
      vibbranteApi
        .vibbranteRejectContract(
          this.data.contract.id,
          this.data.contract.reject_description,
          this.data.contract.cancellation_reason_id.id
        )
        .then(response => {
          if (response.status === 200) {
            vibbranteApi
              .loadPendingContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadVibbranteWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/vibbrante-cancel-contract.vue